import React from 'react';

import { Route, Routes, Navigate, Outlet } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector } from 'react-redux';

import { onBoardRoutes } from './config/routes/onBoardRoutes';
import { notapRoutes } from './config/routes/notapRoutes';
import { appUrls } from './utils/urls/appUrls'
import { transfereeRoutes } from './config/routes/transfereeRoutes';
import { bankRoutes } from './config/routes/bankRoutes';
import { generalRoutes } from './config/routes/generalRoutes';
import { notap_user_roles } from './constants/english';
import { generalProtectedRoutes } from './config/routes/generalProtectedRoutes';
import { guestRoutes } from './config/routes/guestRoutes';
import { getUserToken, persistAuthHeader } from './services/auth';
import { ROLES } from './constants/index';

import AllCertificates from './app/pages/SuperAdmin/AllCertificates';
import Error404 from './app/pages/ErrorPages/Error404';
import FallbackErrorPage from './app/pages/ErrorPages/FallbackErrorPage';
import SuperAdminHome from './app/pages/SuperAdmin/Home';

import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/js/bootstrap.js';
import './App.css';

persistAuthHeader();

function App() {
	return (
		<ErrorBoundary FallbackComponent={FallbackErrorPage} onReset={()=>{window.location.reload()}}>
			<Routes>
				{/* 
					{onBoardRoutes.map((appRoute, j = 0) => {
						return <Route key={j} exact path={appRoute.url} element={appRoute.component} />
					})} 
				*/}

				{/* 
					{appRoutes.map((appRoute, j = 0) => {
						return <Route key={j} path={appRoute.url} element={appRoute.component} />
					})} 
				*/}	
						
				{guestRoutes.map((appRoute, j = 0) => {
					return <Route key={j} exact path={appRoute.url} element={appRoute.component} />
				})}	

				<Route element={<PublicRoute/>} >
					{onBoardRoutes.map((appRoute, j = 0) => {
						return <Route key={j} exact path={appRoute.url} element={appRoute.component} />
					})}
				</Route>

				<Route exact path='' element={<PrivateRoute/>} >
					<Route exact path='' element={<TransfereeRoute/>} >
						{transfereeRoutes.map((appRoute, j = 0) => {
							return <Route key={j} exact path={appRoute.url} element={appRoute.component} />
						})}
					</Route>
				</Route>
				
				<Route exact path='' element={<PrivateRoute/>} >
					<Route exact path='' element={<BankRoute/>} >
						{bankRoutes.map((appRoute, j = 0) => {
							return <Route key={j} exact path={appRoute.url} element={appRoute.component} />
						})}
					</Route>
				</Route>
				
				<Route exact path='' element={<PrivateRoute/>} >
					<Route exact path='' element={<NotapRoute/>} >
						{notapRoutes.map((appRoute, j = 0) => {
							return <Route key={j} path={appRoute.url} element={appRoute.component} />
						})}
					</Route>
				</Route>
				
				<Route exact path='' element={<PrivateRoute/>} >
					{generalProtectedRoutes.map((appRoute, j = 0) => {
						return <Route key={j} exact path={appRoute.url} element={appRoute.component} />
					})}
				</Route>
				
				<Route exact path='' element={<PrivateRoute/>} >
					<Route path={appUrls.adminHome} element={<AdminRoute />}>
						<Route index element={<SuperAdminHome />} />
						<Route path={appUrls.adminCertificates} element={<AllCertificates />} />
					</Route>
				</Route>
				
				{generalRoutes.map((appRoute, j = 0) => {
					return <Route key={j} exact path={appRoute.url} element={appRoute.component} />
				})}

				<Route exact path='*' element={<Error404/>} />
			</Routes>
		</ErrorBoundary>
	);
}

function PrivateRoute() {
	return getUserToken() ? <Outlet /> : <Navigate to={appUrls.login} />;
}

function PublicRoute() {
	const { userData: { user_role } } = useSelector((state) => state.authData);

	const token = getUserToken();

	if (!token) {
		return <Outlet />;
	}

	if (user_role === ROLES.TRANSFEREE.TEXT) {
		return <Navigate to={appUrls.certificates} />;
	}

	if (user_role === ROLES.BANK.TEXT) {
		return <Navigate to={appUrls.bank_certificates} />;
	}

	if (user_role === ROLES.ADMIN.TEXT) {
		return <Navigate to={appUrls.adminHome} />;
	}

	return <Navigate to={appUrls.notap_certificates} />;
}

function NotapRoute() {
	const { userData: { user_role } } = useSelector((state) => state.authData);
	const isNotap = notap_user_roles.includes(user_role?.toLowerCase());

	return isNotap ? <Outlet /> : <Error404 />
}

function BankRoute() {
	const { userData:{ user_role } } = useSelector((state) => state.authData)

	return user_role === ROLES.BANK.TEXT ? <Outlet /> : <Error404 />
}

function TransfereeRoute() {
	const { userData: { user_role } } = useSelector((state) => state.authData);

	return user_role === ROLES.TRANSFEREE.TEXT ? <Outlet /> : <Error404/>
}

function AdminRoute() {
	const { userData: { user_role } } = useSelector((state) => state.authData);

	return user_role === ROLES.ADMIN.TEXT ? <Outlet /> : <Error404/>
}

export default App;
